import { QUERY_OUTPUT } from "types/outputFormat";

export const createURLSearchParams = (
  existingSearchParams: URLSearchParams,
  params: { [key: string]: string }
) => {
  const searchParams = new URLSearchParams();

  for (const [key, value] of [
    ...existingSearchParams.entries(),
    ...Object.entries(params),
  ]) {
    searchParams.append(key, value);
  }

  return searchParams.toString();
};

export const buildEngineUrl = (
  engineURL: URL,
  params: { [key: string]: string }
) => {
  const isLite = Boolean(process.env.REACT_APP_LITE);

  if (isLite) {
    const overrideParams: Record<string, string> = {
      ...params,
      output_format: QUERY_OUTPUT.JSON_COMPACT,
    };

    delete overrideParams.auto_start_stop_control;

    const searchParams = createURLSearchParams(
      engineURL.searchParams,
      overrideParams
    );

    return `http://${window.location.host}/query?${searchParams}`;
  }

  const searchParams = createURLSearchParams(engineURL.searchParams, params);

  return `${engineURL.protocol}//${engineURL.host}${engineURL.pathname}?${searchParams}`;
};
